import { render } from "./CommandEditor.vue?vue&type=template&id=4f84dc22"
import script from "./CommandEditor.vue?vue&type=script&lang=ts"
export * from "./CommandEditor.vue?vue&type=script&lang=ts"
script.render = render

export default script